import { Component, OnInit } from '@angular/core';
import { Question } from '../../../../models/question';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { QuestionType } from '../../../../models/question-type';
import { QuestionFactorType } from '../../../../models/question-factor-type';
import { QuestionAnswer } from '../../../../models/question-answer';
import { Threat } from '../../../../models/threat';

@Component({
  selector: 'lib-upsert-threat-question-modal',
  templateUrl: './upsert-threat-question-modal.component.html',
  styleUrls: ['./upsert-threat-question-modal.component.scss']
})
export class UpsertThreatQuestionModalComponent implements OnInit {
  public question: Question;
  public questions: Array<Question> = [];
  public threat: Threat;
  public isOverAllTemplate: boolean = false;
  public submitted = false;
  public maxNameLength = 200;
  public questionType = QuestionType;
  public questionFactorType = QuestionFactorType;
  public questionAnswer = QuestionAnswer;

  get isValid(): boolean {
    let isValid = true;

    if (!this.question.name ||
      this.question.name.length > this.maxNameLength) {
      isValid = false;
    }
    if ((!this.question.evenWeight && this.question.weight == null) || this.question.type == null) {
      isValid = false;
    }
    if (this.question.type === QuestionType.yesNo && (!this.isOverAllTemplate && this.question.factorType == null || this.question.increasingAnswer == null)) {
      isValid = false;
    }

    return isValid;
  }

  get canChangeType(): boolean {
    return this.question && this.question.conditionalDependsUid == null && this.questions.findIndex(q => q.conditionalDependsUid === this.question.uid) === -1;
  }

  constructor(public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig) {
    this.question = this.dynamicDialogConfig?.data?.question || new Question();
    this.questions = this.dynamicDialogConfig?.data?.questions;
    this.threat = this.dynamicDialogConfig?.data?.threat;
    this.isOverAllTemplate = this.dynamicDialogConfig?.data?.isOverAllTemplate;
  }

  ngOnInit(): void {
  }

  save(): void {
    this.submitted = true;

    // validation
    if (!this.isValid) {
      return;
    }

    if (this.question.type === QuestionType.impactProbability) {
      this.question.factorType = QuestionFactorType.both;
    } else if (this.isOverAllTemplate) {
      this.question.factorType = null;
    }
    this.dynamicDialogRef.close(this.question);
  }

  cancel(): void {
    this.dynamicDialogRef.destroy();
  }

  onQuestionTypeChanged(): void {
    if (this.question.type === QuestionType.yesNo && !this.isOverAllTemplate && this.question.factorType == null) {
      this.question.factorType = QuestionFactorType.impact;
    }
  }
}
